module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/0.75-7afdd79d71c5fbc9cd76c6bc9e009b68.svg";